import { Tooltip } from 'antd'
import { useAtom } from 'jotai'
import { optionsAtom, paintTimesAtom } from './atom'
import Stepper from '../Stepper'
import { QuestionCircleOutlined } from '@ant-design/icons'

export const PaintTimesComp = () => {
  const [options] = useAtom(optionsAtom)
  const [paintTimes, setPaintTimes] = useAtom(paintTimesAtom)

  return (
    <div className="flex items-center justify-between mb-4">
      <span className="text-neutral-500">
        作图数量{' '}
        <Tooltip
          placement="topLeft"
          arrowPointAtCenter
          title="每增加1张作图数量将成倍增加消耗的总积分"
        >
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
      <Stepper
        step={1}
        min={1}
        max={options!.numCeiling || 100}
        value={paintTimes}
        onChange={setPaintTimes}
      />
    </div>
  )
}
